<ngx-loader-spinner>
    <span>Saving...</span>
</ngx-loader-spinner>
<router-outlet></router-outlet>